import { Component } from '@angular/core';

@Component({
    selector: 'fh-stepper',
    styleUrls: ['./stepper.component.scss'],
    templateUrl: './stepper.component.html',
})
export class StepperComponent
{
}
